export default "__VITE_ASSET__mm5t6XmY__"